export enum RoleLabels {
    CHAPTER_PRESIDENT = "Chapter President",
    CEC = "Chapter Executive Committee",
    NEC = "National Executive Committee",
    NEC_PRESIDENT = "President, National Executive Committee",
    NON_MEMBER = "Non-Member",
    MEMBER = "Member",
    SYS_ADMIN = "System Administrator"

    // add more roles as needed
}